var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutUsTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 163,
    viewBox: "0 0 1280 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 149C0 149 155.813 109.489 260.5 119.5C331.499 126.29 366.782 158.622 438 162.5C538.798 167.989 564.021 122.125 647.5 119.5C746.131 116.399 808.712 146.631 891.5 150.5C992.719 155.23 1074.42 92.1567 1185 119.5C1227.84 130.093 1280 144 1280 144V0L0 0L0 149Z",
    fill: "#EA5455",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 152C0 152 81.1833 163.077 138 162.5C236.482 161.5 288.166 124.994 386.5 119.5C514.38 112.355 584.997 154.917 713 150.5C836.325 146.244 902.239 87.9724 1025 100.5C1100.39 108.194 1136.8 153.957 1212.5 150.5C1242.96 149.109 1280 146.5 1280 146.5V0L0 0L0 152Z",
    fill: "#EA5455",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 149.5C0 149.5 61.3639 140.323 105.5 137.5C220.358 130.153 284.441 155.203 399.5 158C521.928 160.975 559.4 164.668 661.5 158C804.915 148.634 864.829 135.913 995.5 137.5C1080.39 138.531 1117.8 163.957 1193.5 160.5C1223.96 159.109 1280 138.5 1280 138.5V0L0 0L0 149.5Z",
    fill: "#EA5455",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsTop);
export default __webpack_public_path__ + "static/media/AboutUsTop.03e54fd97532dbf69bf33236d19d26c4.svg";
export { ForwardRef as ReactComponent };